module.exports = __webpack_public_path__ + "img/interactive-intro.8d3af271.png";